import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './slotpage.css';

const SlotSelectionPage = () => {
  const { matchId } = useParams();
  const navigate = useNavigate();

  const [slots, setSlots] = useState([]);
  const [match, setMatch] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchSlots = async () => {
      try {
        const res = await axios.get(`https://backend.aubattle.com/api/matches/${matchId}/slots`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        setMatch(res.data.match);
        setSlots(res.data.slots);
      } catch (err) {
        console.error("Failed to fetch slots", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSlots();
  }, [matchId]);

  const handleSlotSelect = (slotNumber) => {
    setSelectedSlot(slotNumber);
  };

  const handleJoinMatch = async () => {
    try {
      await axios.post(`https://backend.aubattle.com/api/matches/${matchId}/join`, {
        slotNumber: selectedSlot
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      alert("Successfully joined the match!");
      navigate('/dashboard');
    } catch (err) {
      alert(err.response?.data?.message || "Failed to join match.");
       navigate('/mywallet');
    }
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading match data...</p>
      </div>
    );
  }

  return (
    <div className="slot-selection-container">
      <button 
        className="back-btn"
        onClick={() => navigate(-1)}
      >
        <i className="bi bi-chevron-left"></i> Back to Matches
      </button>
      
      <div className="match-header">
        <h2>{match?.title}</h2>
        <div className="match-meta">
          <span className="meta-item">Slots: {slots.length}/{match?.max_players}</span>
          {match?.game_type && <span className="meta-item">Game: {match?.game_type}</span>}
        </div>
      </div>

      <div className="slots-grid">
        {[...Array(Number(match?.max_players) || 0)].map((_, i) => {
          const slotNum = i + 1;
          const slot = slots.find((s) => s.slot_number === slotNum);
          const isTaken = !!slot;

          return (
            <label 
              key={i} 
              className={`slot-checkbox-label ${isTaken ? 'taken' : ''} ${selectedSlot === slotNum ? 'selected' : ''}`}
            >
              <input
                type="checkbox"
                disabled={isTaken}
                checked={selectedSlot === slotNum}
                onChange={() => handleSlotSelect(slotNum)}
              />
              <span className="slot-number">Slot {slotNum}</span>
              {isTaken ? (
                <span className="slot-status taken-status">TAKEN</span>
              ) : (
                <span className="slot-status available-status">AVAILABLE</span>
              )}
            </label>
          );
        })}
      </div>

      {selectedSlot && (
        <div className="join-button-container">
          <button onClick={handleJoinMatch} className="join-btn">
            Claim Slot {selectedSlot}
          </button>
        </div>
      )}
    </div>
  );
};

export default SlotSelectionPage;